import type { TFunction } from 'i18next'
import { BillingTier } from '@zeus/index'

/**
 * Libellé du palier qu'il faudrait à une organisation qui dépasse le sien (#149).
 * Au-delà du dernier palier, c'est un devis : `CUSTOM` se lit ailleurs « Géré par
 * Studeva » (#349), ce qui serait faux ici.
 */
export function neededTierLabel(t: TFunction, tier: BillingTier): string {
  return tier === BillingTier.CUSTOM ? t('billing.quote') : t(`billing.tier.${tier}`)
}
